import { addStyles } from 'ethcss'
import { IStyles } from 'theme'

export const styles: IStyles = {
    NetworkConverter__content: {},
}

addStyles(styles)
